import React from 'react';
import { Box } from '@mui/joy';
import SEO from '../components/common/SEO';
import AboutStyleScroll from '../components/about/AboutStyleScroll';

const AboutPage = () => {
    return (
        <>
            <SEO 
                title="About Hubitable - Making Healthy Living Easy"
                description="Learn about Hubitable's mission to make healthy lifestyle the easy lifestyle through AI-powered solutions that adapt to your ever-changing schedule."
            />
            
            <Box>
                {/* Apple-style scroll experience for About page */}
                <AboutStyleScroll />
            </Box>
        </>
    );
};

export default AboutPage; 